import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Dialog from "@material-ui/core/Dialog";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import Slide from "@material-ui/core/Slide";
import KuisPart4 from "../4/KuisPart4/KuisPart4";
// import Formsiswa from '../4/KuisPart4/Formsiswa'
import Petunjuk from "./Petunjuk";

const useStyles = makeStyles((theme) => ({
	appBar: {
		position: "relative",
		backgroundColor: "#40bf80",
	},
	title: {
		margin: "auto",
	},
}));

const Transition = React.forwardRef(function Transition(props, ref) {
	return <Slide direction="up" ref={ref} {...props} />;
});
const Part4 = () => {
	const classes = useStyles();
	const [open, setOpen] = useState(false);

	const handleClickOpen = () => {
		setOpen(true);
	};

	const handleClose = () => {
		setOpen(false);
	};
	return (
		<div>
			<div className="container">
				<div className="d-flex justify-content-center mt-4">
					<Petunjuk />
				</div>
				<div className="d-flex justify-content-center mt-4">
					<button
						className="text-center btn btn-outline-success mt-3"
						onClick={handleClickOpen}
					>
						Mulai
					</button>

					<Dialog
						fullScreen
						open={open}
						onClose={handleClose}
						TransitionComponent={Transition}
					>
						<AppBar className={classes.appBar}>
							<Toolbar>
								<IconButton
									edge="start"
									color="inherit"
									onClick={handleClose}
									aria-label="close"
								>
									<CloseIcon />
								</IconButton>
								<h4 className={classes.title}>Kuis Pertidaksamaan Linear</h4>
							</Toolbar>
						</AppBar>
						{/* <Formsiswa /> */}
						<KuisPart4 />
					</Dialog>
				</div>
			</div>
		</div>
	);
};

export default Part4;
